import React from 'react';

import PaymentsGraphic from 'images/TrustyPaymentsGraphic.png';
import ValuePropsModal from 'components/paywall/ValuePropsModal';
import { translate } from 'translations/i18n';

type PaymentsValuePropModalProps = {
  onRequestClose: () => void;
};

const PaymentsValuePropModal = ({
  onRequestClose,
}: PaymentsValuePropModalProps) => {
  return (
    <ValuePropsModal
      description={translate('payments.valuePropsModal.description')}
      checklistItems={[
        translate('payments.valuePropsModal.valueProp1'),
        translate('payments.valuePropsModal.valueProp2'),
        translate('payments.valuePropsModal.valueProp3'),
      ]}
      title={translate('payments.valuePropsModal.title')}
      image={PaymentsGraphic}
      onRequestClose={onRequestClose}
      trackingAction="payments_value_prop_opened"
      dataTestId="payments"
    />
  );
};

export default PaymentsValuePropModal;
